<template>
  <div class="relative">
    <div class="vx-navbar-wrapper navbar-full p-0">
      <vs-navbar class="navbar-custom navbar-skelton" :class="navbarClasses" :style="navbarStyle"
                 :color="navbarColor">
        <template v-if="windowWidth < 1200 && isLogin">
          <div @click="toggleMenu()">
            <feather-icon icon="MenuIcon" class="cursor-pointer mr-5"/>
          </div>
        </template>
        <a :href="home"
           class="vx-logo cursor-pointer mx-auto flex items-center align-items-start flex-1">
          <img :src="logo" alt="logo" class="mr-4" style="max-width: 75px" v-if="logo">
        </a>

        <!-- CART DROPDOWN -->
        <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
          <feather-icon icon="ShoppingCartIcon"
                        class="cursor-pointer ltr:ml-6 rtl:mr-6 ltr:mr-6 rtl:ml-6 mt-1"
                        :badge="cartItems.length"></feather-icon>
          <vs-dropdown-menu class="cart-dropdown vx-navbar-dropdown leftx"
                            :class="{'dropdown-custom': cartItems.length}">

            <!-- IF CART HAVE ITEMS: HEADER -->
            <template v-if="cartItems.length">
              <div class="notification-header text-center p-5 bg-primary text-white">
                <h3 class="text-white">{{ cartItems.length }} item </h3>
                <p class="opacity-75">Your cart</p>
              </div>

              <!-- CART ITEMS -->
              <VuePerfectScrollbar ref="mainSidebarPs" class="scroll-area--cart-items-dropdowm p-0 mb-10"
                                   :settings="settings">
                <ul class="bordered-items">
                  <li v-for="item in cartItems" :key="item.objectID"
                      class="vx-row no-gutter cart-item">

                    <!-- IMG COL -->
                    <div class="vx-col w-1/5 item-img-container bg-white flex items-center justify-center">
                      <vs-avatar :src="getImg(item)" alt="item" size="large"/>
                    </div>

                    <!-- INFO COL -->
                    <div class="vx-col w-4/5 pr-4 pl-2 py-4 flex flex-col justify-center">
                      <span class="font-medium block cart-item-title truncate">{{ item.title }}</span>
                      <div class="flex items-center justify-between">
                        <span class="text-sm font-medium">{{ item.qty }} <small>x</small> {{getPrice(item)}} </span>
                        <span class="font-bold">{{getPrice(item)* item.qty}}</span>
                        <feather-icon icon="Trash2Icon"
                                      svgClasses="h-6 w-6 cursor-pointer text-danger"
                                      class="hover:text-danger"
                                      @click.stop="removeItemFromCart(item)"/>
                      </div>
                    </div>
                  </li>
                </ul>
              </VuePerfectScrollbar>
              <div
                class=" checkout-footer fixed bottom-0 rounded-b-lg text-primary font-semibold w-full p-2 text-center border border-b-0 border-l-0 border-r-0 border-solid d-theme-border-grey-light cursor-pointer"
                @click="$router.push('/checkout').catch(() => {})">

                            <span class="flex items-center justify-center">
                              <feather-icon icon="ShoppingCartIcon" svgClasses="h-4 w-4"></feather-icon>
                              <span class="ml-2">View Cart</span>
                            </span>

              </div>
            </template>

            <!-- IF CART IS EMPTY -->
            <template v-else>
              <p class="p-4">There are no items in your cart.</p>
            </template>
          </vs-dropdown-menu>
        </vs-dropdown>
        <template v-if="windowWidth >= 992">
          <!-- STARRED PAGES - FIRST 10 -->
          <!--<ul class="vx-navbar__starred-pages">-->
          <!--<draggable v-model="starredPagesLimited" :group="{name: 'pinList'}" class="flex cursor-move">-->
          <!--<li class="starred-page" v-for="page in starredPagesLimited" :key="page.url">-->
          <!--<vx-tooltip :text="page.label" position="bottom" delay=".3s">-->
          <!--<feather-icon svgClasses="h-6 w-6" class="p-2 cursor-pointer" :icon="page.labelIcon"-->
          <!--@click="$router.push(page.url).catch(() => {})"/>-->
          <!--</vx-tooltip>-->
          <!--</li>-->
          <!--</draggable>-->
          <!--</ul>-->

          <!-- STARRED PAGES MORE -->
          <!--<div class="vx-navbar__starred-pages&#45;&#45;more-dropdown" v-if="starredPagesMore.length">-->
          <!--<vs-dropdown vs-custom-content vs-trigger-click>-->
          <!--<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"-->
          <!--class="cursor-pointer p-2"></feather-icon>-->
          <!--<vs-dropdown-menu>-->
          <!--<ul class="vx-navbar__starred-pages-more&#45;&#45;list">-->
          <!--<draggable v-model="starredPagesMore" :group="{name: 'pinList'}"-->
          <!--class="cursor-move">-->
          <!--<li class="starred-page&#45;&#45;more flex items-center cursor-pointer"-->
          <!--v-for="page in starredPagesMore" :key="page.url"-->
          <!--@click="$router.push(page.url).catch(() => {})">-->
          <!--<feather-icon svgClasses="h-5 w-5" class="ml-2 mr-1"-->
          <!--:icon="page.labelIcon"></feather-icon>-->
          <!--<span class="px-2 pt-2 pb-1">{{ page.label }}</span>-->
          <!--</li>-->
          <!--</draggable>-->
          <!--</ul>-->
          <!--</vs-dropdown-menu>-->
          <!--</vs-dropdown>-->
          <!--</div>-->

          <!--<div class="bookmark-container">-->
          <!--<feather-icon icon="StarIcon" svgClasses="stoke-current text-warning" class="cursor-pointer p-2"-->
          <!--@click.stop="showBookmarkPagesDropdown = !showBookmarkPagesDropdown"/>-->
          <!--<div v-click-outside="outside" class="absolute bookmark-list w-1/3 xl:w-1/4 mt-4"-->
          <!--v-if="showBookmarkPagesDropdown">-->
          <!--<vx-auto-suggest :autoFocus="true" :data="navbarSearchAndPinList" @selected="selected"-->
          <!--@actionClicked="actionClicked" inputClassses="w-full" show-action-->
          <!--show-pinned background-overlay></vx-auto-suggest>-->
          <!--</div>-->
          <!--</div>-->
        </template>

        <!-- SEARCHBAR -->
        <div class="search-full-container w-full h-full absolute left-0" :class="{'flex': showFullSearch}"
             v-show="showFullSearch">
          <vx-auto-suggest
            class="w-full"
            inputClassses="w-full vs-input-no-border vs-input-no-shdow-focus"
            :autoFocus="showFullSearch"
            :data="navbarSearchAndPinList"
            icon="SearchIcon"
            placeholder="Search..."
            ref="navbarSearch"
            @closeSearchbar="showFullSearch = false"
            @selected="selected"
            background-overlay/>
          <div class="absolute right-0 h-full z-50">
            <feather-icon icon="XIcon" class="px-4 cursor-pointer h-full close-search-icon"
                          @click="showFullSearch = false"></feather-icon>
          </div>
        </div>


        <!-- USER META -->
        <div class="the-navbar__user-meta flex items-center" v-if="isLogin">
          <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

            <div class="flex items-center">

              <div class="con-img ltr:mr-3 rtl:ml-3">
                <img
                  key="onlineImg"
                  src="@/assets/profile.jpg"
                  alt="user-img"
                  width="40"
                  height="40"
                  class="rounded-full shadow-md cursor-pointer block"/>

              </div>
              <div class="text-right leading-tight hidden sm:block ">
                <p class="font-semibold">{{ user_displayName }}</p>
                <small></small>
              </div>
            </div>
            <vs-dropdown-menu class="vx-navbar-dropdown">
              <ul style="min-width: 9rem">
                <li
                  class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  @click="$router.push('/profile').catch(() => {})">

                  <feather-icon icon="UserIcon" svgClasses="w-4 h-4"/>
                  <span class="ltr:ml-2 rtl:mr-2">{{$t('Profile')}}</span>
                </li>
                             <vs-divider class="m-1"></vs-divider>

                <li
                  class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  @click="logout">
                  <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4"/>
                  <span class="ltr:ml-2 rtl:mr-2">{{$t('Logout')}}</span>
                </li>
              </ul>
            </vs-dropdown-menu>
          </vs-dropdown>

        </div>

      </vs-navbar>
    </div>
  </div>
</template>

<script>
  // import 'firebase/auth'
  import VxAutoSuggest from '@/components/vx-auto-suggest/VxAutoSuggest.vue';
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import draggable from 'vuedraggable'
  import _ from 'lodash';
  import themeConfig from '@/../themeConfig';

  export default {
    name: "the-navbar",
    props: {
      logo: {type: String},
      navbarType: {
        type: String,
        required: true
      }
    },

    data() {
      return {
        navbarSearchAndPinList: this.$store.state.navbarSearchAndPinList,
        searchQuery: '',
        showFullSearch: false,
        unreadNotifications: [
          {
            index: 0,
            title: 'New Message',
            msg: 'Are your going to meet me tonight?',
            icon: 'MessageSquareIcon',
            time: this.randomDate({sec: 10}),
            category: 'primary'
          },
          {
            index: 1,
            title: 'New Order Recieved',
            msg: 'You got new order of goods.',
            icon: 'PackageIcon',
            time: this.randomDate({sec: 40}),
            category: 'success'
          },
          {
            index: 2,
            title: 'Server Limit Reached!',
            msg: 'Server have 99% CPU usage.',
            icon: 'AlertOctagonIcon',
            time: this.randomDate({min: 1}),
            category: 'danger'
          },
          {
            index: 3,
            title: 'New Mail From Peter',
            msg: 'Cake sesame snaps cupcake',
            icon: 'MailIcon',
            time: this.randomDate({min: 6}),
            category: 'primary'
          },
          {
            index: 4,
            title: 'Bruce\'s Party',
            msg: 'Chocolate cake oat cake tiramisu',
            icon: 'CalendarIcon',
            time: this.randomDate({hr: 2}),
            category: 'warning'
          },
        ],
        settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
        },
        autoFocusSearch: false,
        showBookmarkPagesDropdown: false,
      }
    },
    watch: {
      '$route'() {
        if (this.showBookmarkPagesDropdown) this.showBookmarkPagesDropdown = false
      }
    },
    computed: {
      home() {
        return themeConfig.domain;
      },
      isLogin(){
        return localStorage.getItem('accessToken') != undefined;
      },
      navbarColor() {
        let color = "#fff"
        if (this.navbarType === "sticky") color = "#f7f7f7"
        else if (this.navbarType === 'static') {
          if (this.scrollY < 50) {
            color = "#f7f7f7"
          }
        }

        this.isThemedark === "dark" ? color === "#fff" ? color = "#10163a" : color = "#262c49" : null

        return color
      },
      isThemedark() {
        return this.$store.state.theme;
      },
      i18n_locale_img() {
        return require(`@/assets/images/flags/${this.$i18n.locale}.png`)
      },
      navbarStyle() {
        let style = {}

        if (this.navbarType === "static") {
          style.transition = "all .25s ease-in-out"

          // if(this.scrollY < 50) {
          //   style.background = "#262c49"
          // }
        }

        return style
      },
      navbarClasses() {
        return this.scrollY > 5 && this.navbarType === "static" ? null : "d-theme-dark-light-bg shadow-none"
      },
      scrollY() {
        return this.$store.state.scrollY
      },

      // HELPER
      verticalNavMenuWidth() {
        return this.$store.state.verticalNavMenuWidth
      },
      windowWidth() {
        return this.$store.state.windowWidth
      },

      // I18N
      getCurrentLocaleData() {
        const locale = this.$i18n.locale;
        if (locale == "en") return {flag: "us", lang: 'English'}
        else if (locale == "fa") return {flag: "fa", lang: 'Farsi'}
        else if (locale == "pt") return {flag: "br", lang: 'Portuguese'}
        else if (locale == "fr") return {flag: "fr", lang: 'French'}
        else if (locale == "de") return {flag: "de", lang: 'German'}
      },

      // BOOKMARK & SEARCH
      data() {
        return this.$store.state.navbarSearchAndPinList;
      },
      starredPages() {
        return this.$store.state.starredPages;
      },
      starredPagesLimited: {
        get() {
          return this.starredPages.slice(0, 10);
        },
        set(list) {
          this.$store.dispatch('arrangeStarredPagesLimited', list);
        }
      },
      starredPagesMore: {
        get() {
          return this.starredPages.slice(10);
        },
        set(list) {
          this.$store.dispatch('arrangeStarredPagesMore', list);
        }
      },

      // CART DROPDOWN
      cartItems() {
        return this.$store.state.eCommerce.cartItems.slice().reverse();
      },

      // PROFILE
      activeUserInfo() {
        console.log('this.$store.state.AppActiveUser', this.$store.state.AppActiveUser);
        return this.$store.state.AppActiveUser
      },
      user_displayName() {
        return this.activeUserInfo.name
      },
      activeUserImg() {
        return this.$store.state.AppActiveUser.photoURL;
      }
    },
    methods: {
      updateLocale(locale) {
        this.$i18n.locale = locale;
      },
      toggleMenu() {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true);
      },
      selected(item) {
        this.$router.push(item.url).catch(() => {
        })
        this.showFullSearch = false;
      },
      getImg(item) {
        return _.get(item, 'image.src')
      },
      getPrice(item) {
        return _.get(item, 'variants.0.price', 0);
      },
      actionClicked(item) {
        // e.stopPropogation();
        this.$store.dispatch('updateStarredPage', {index: item.index, val: !item.highlightAction});
      },
      showNavbarSearch() {
        this.showFullSearch = true;
      },
      showSearchbar() {
        this.showFullSearch = true;
      },
      elapsedTime(startTime) {
        let x = new Date(startTime);
        let now = new Date();
        var timeDiff = now - x;
        timeDiff /= 1000;

        var seconds = Math.round(timeDiff);
        timeDiff = Math.floor(timeDiff / 60);

        var minutes = Math.round(timeDiff % 60);
        timeDiff = Math.floor(timeDiff / 60);

        var hours = Math.round(timeDiff % 24);
        timeDiff = Math.floor(timeDiff / 24);

        var days = Math.round(timeDiff % 365);
        timeDiff = Math.floor(timeDiff / 365);

        var years = timeDiff;

        if (years > 0) {
          return years + (years > 1 ? ' Years ' : ' Year ') + 'ago';
        } else if (days > 0) {
          return days + (days > 1 ? ' Days ' : ' Day ') + 'ago';
        } else if (hours > 0) {
          return hours + (hours > 1 ? ' Hrs ' : ' Hour ') + 'ago';
        } else if (minutes > 0) {
          return minutes + (minutes > 1 ? ' Mins ' : ' Min ') + 'ago';
        } else if (seconds > 0) {
          return seconds + (seconds > 1 ? ' sec ago' : 'just now');
        }

        return 'Just Now'
      },
      logout() {

        console.log('localStorage.getItem("accessToken")', localStorage.getItem("accessToken"));
        // If JWT login
        if (localStorage.getItem("accessToken")) {
          localStorage.removeItem("accessToken")
          this.$router.push('/auth/login').catch(() => {
          });

        } else {
          this.$router.push('/auth/login').catch(() => {
          })
        }
        window.location.reload();
        // Change role on logout. Same value as initialRole of acj.js
        this.$acl.change('admin')
        localStorage.removeItem('userInfo')
      },
      outside: function () {
        this.showBookmarkPagesDropdown = false
      },

      // CART DROPDOWN
      removeItemFromCart(item) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Confirm`,
          text: 'Are you sure you want to remove the item from the cart?',
          accept: () => {
            this.$store.dispatch('eCommerce/toggleItemInCart', item)
          }
        });
      },

      // Method for creating dummy notification time
      randomDate({hr, min, sec}) {
        let date = new Date()

        if (hr) date.setHours(date.getHours() - hr)
        if (min) date.setMinutes(date.getMinutes() - min)
        if (sec) date.setSeconds(date.getSeconds() - sec)

        return date
      }
    },
    directives: {
      'click-outside': {
        bind: function (el, binding) {
          const bubble = binding.modifiers.bubble
          const handler = (e) => {
            if (bubble || (!el.contains(e.target) && el !== e.target)) {
              binding.value(e)
            }
          }
          el.__vueClickOutside__ = handler
          document.addEventListener('click', handler)
        },

        unbind: function (el) {
          document.removeEventListener('click', el.__vueClickOutside__)
          el.__vueClickOutside__ = null

        }
      }
    },
    components: {
      VxAutoSuggest,
      VuePerfectScrollbar,
      draggable
    },
  }
</script>
